import { UiButton } from "~/components/ui-button";
import styles from "./product-cloud-title.module.css";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";

export const ProductCloudTitle = ({
  title,
  favorite,
  className,
  onFavorite,
  onShareProduct






}: {title: string;favorite?: boolean;className?: string;onFavorite?: () => void;onShareProduct?: () => void;}) => {
  const { theme } = useGlobalStyles();
  const handleFavorite = () => {
    onFavorite && onFavorite();
  };

  const handleShareProduct = () => {
    onShareProduct && onShareProduct();
  };

  return (
    <header
      role='heading'
      aria-label='product-detail-title'
      className={`${styles.ProductSkin1Title} ${className || ""}`}>

      <h1 className={`${styles.productSkin1Title}`}>{title}</h1>
      <div className={`${styles.productSkin1TitleActions}`}>
        {onShareProduct &&
        <UiButton
          size='short'
          isBlack
          className={`${styles.buttonShare}`}
          onClick={handleShareProduct}
          rightIcon={
          <span
            className={`product-title-action-icon icon-share-outline`} />} />}




        {onFavorite &&
        <button
          className={`${styles.productTitleAction} ${
          favorite ? styles.productTitleFavoriteActive : ""
          }`}
          onClick={handleFavorite}>

            <span className='product-title-action-icon icon-heart'></span>
          </button>}

      </div>
    </header>);

};